import { render, staticRenderFns } from "./WarningsDetailTable.vue?vue&type=template&id=15614d35&scoped=true&"
import script from "./WarningsDetailTable.vue?vue&type=script&lang=ts&"
export * from "./WarningsDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./WarningsDetailTable.vue?vue&type=style&index=0&id=15614d35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15614d35",
  null
  
)

export default component.exports